// Le lingue del sito. I testi nel codice sono in italiano, la lingua di
// partenza: non ha dizionario. Ogni altra lingua ha il suo in
// `src/i18n/locales/<codice>.json` (testo italiano → traduzione).
//
// Aggiungere una lingua:
//  1. una voce qui, col nome scritto in quella lingua (lo mostra il selettore);
//  2. il suo dizionario `locales/<codice>.json` (si parte da una copia di
//     `en.json` e si traducono i valori) e il suo caricamento in
//     `loadDictionary` (src/i18n/index.js);
//  3. `npm test` controlla che il dizionario copra i testi del sito
//     (tests/unit/i18n/dictionary-coverage.spec.js).
export const SOURCE_LANGUAGE = 'it';

export const LANGUAGES = [
  { code: 'it', nativeName: 'Italiano', short: 'IT' },
  { code: 'en', nativeName: 'English', short: 'EN' },
];

export function languageFromCode(code) {
  if (typeof code !== 'string') return null;
  const normalized = code.trim().toLowerCase();
  return LANGUAGES.find((l) => l.code === normalized) || null;
}
